/** Pure decisions behind the install banner; DOM wiring lives in ui/install-banner.ts. */

export const DISMISSAL_TTL_MS = 14 * 24 * 60 * 60 * 1000;

export const DISMISSAL_STORAGE_KEY = 'syncport.install-dismissed-at';

export type InstallEnvironment = Readonly<{
  /** Already running as an installed app. */
  standalone: boolean;
  userAgent: string;
  dismissedAtMs: number | null;
  nowMs: number;
}>;

export type InstallOffer = 'native-prompt' | 'ios-instructions' | 'none';

export const isIosBrowser = (userAgent: string): boolean => /iPhone|iPad|iPod/i.test(userAgent);

export const isDismissalActive = (dismissedAtMs: number | null, nowMs: number): boolean =>
  dismissedAtMs !== null && nowMs - dismissedAtMs < DISMISSAL_TTL_MS;

/** Which kind of install offer, if any, the page should prepare for this visitor. */
export const installOfferFor = (env: InstallEnvironment): InstallOffer => {
  if (env.standalone || isDismissalActive(env.dismissedAtMs, env.nowMs)) {
    return 'none';
  }
  return isIosBrowser(env.userAgent) ? 'ios-instructions' : 'native-prompt';
};

export const parseDismissedAt = (stored: string | null): number | null => {
  if (stored === null) {
    return null;
  }
  const value = Number(stored);
  return Number.isFinite(value) ? value : null;
};
